/**
 * Breadcrumbs - Navigation trail for catalog and detail pages
 */

import type React from 'react';
import { Link } from 'react-router';

import * as styles from './Breadcrumbs.css';

export interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
}

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items }) => (
  <nav className={styles.breadcrumbs} aria-label="Breadcrumb">
    <ol className={styles.list}>
      {items.map((item, index) => {
        const isLast = index === items.length - 1;

        return (
          <li key={`${item.label}-${index}`} className={styles.item}>
            {item.to ? (
              <Link to={item.to} className={styles.link}>
                {item.label}
              </Link>
            ) : (
              <span className={styles.current} aria-current="page">
                {item.label}
              </span>
            )}
            {!isLast && <span className={styles.separator}>/</span>}
          </li>
        );
      })}
    </ol>
  </nav>
);
